
import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { useCandidateActions } from '@/hooks/useCandidateActions';

interface MessageDialogProps {
  isOpen: boolean;
  onClose: () => void;
  candidateId: string;
  candidateName: string;
  candidateEmail?: string;
}

export const MessageDialog: React.FC<MessageDialogProps> = ({
  isOpen,
  onClose,
  candidateId,
  candidateName,
  candidateEmail,
}) => {
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const { sendMessage, isProcessing } = useCandidateActions();

  const handleSend = async () => {
    if (!message.trim()) return;
    
    const fullMessage = `Subject: ${subject}\n\n${message}`;
    const success = await sendMessage(candidateId, fullMessage);
    
    if (success) {
      setSubject('');
      setMessage('');
      onClose();
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[525px]">
        <DialogHeader>
          <DialogTitle>Send Message to {candidateName}</DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="grid gap-2">
            <Label htmlFor="email">To:</Label>
            <Input
              id="email"
              value={candidateEmail || 'No email available'}
              disabled
            />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="subject">Subject:</Label>
            <Input
              id="subject"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              placeholder="Enter subject..."
            />
          </div>
          <div className="grid gap-2">
            <Label htmlFor="message">Message:</Label>
            <Textarea
              id="message"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Enter your message..."
              rows={6}
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            Cancel
          </Button>
          <Button 
            onClick={handleSend} 
            disabled={isProcessing || !message.trim()}
          >
            {isProcessing ? 'Sending...' : 'Send Message'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
